/* eslint-disable camelcase */
/* eslint-disable sort-imports-es6-autofix/sort-imports-es6 */
import page1 from 'reg_redesign/config/page1_intro';
import page2 from 'reg_redesign/config/page2_name_referral';
import page3 from 'reg_redesign/config/page3_email_phone';
import page3_1 from 'reg_redesign/config/page3_1_loan_purpose';
import page4 from 'reg_redesign/config/page4_dob_ssn';
import page5 from 'reg_redesign/config/page5_address';
import page5_1 from 'reg_redesign/config/page5_1_are_you_married';
import page5_2 from 'reg_redesign/config/page5_2_spouse_name';
import page5_3 from 'reg_redesign/config/page5_3_spouse_address';
import page6 from 'reg_redesign/config/page6_gross_monthly_income';
import page7 from 'reg_redesign/config/page7_primary_income_source';
import page7_1 from 'reg_redesign/config/page7_1_employment';
import page7_1_2 from 'reg_redesign/config/page7_1_2_other_income_source';
import page7_2 from 'reg_redesign/config/page7_2_length_of_employment';
import page7_2_2 from 'reg_redesign/config/page7_2_2_length_of_income';
import page8 from 'reg_redesign/config/page8_pay_frequency';
import page8_1 from 'reg_redesign/config/page8_1_pay_dates';
import page9 from 'reg_redesign/config/page9_pay_type';
import page10 from 'reg_redesign/config/page10_bank_account_type';
import page11 from 'reg_redesign/config/page11_bank_info';
import page12 from 'reg_redesign/config/page12_bank_account_age';
import page13 from 'reg_redesign/config/page13_loan_amount';
import page14 from 'reg_redesign/config/page14_password';
import page15 from 'reg_redesign/config/page15_disclosures';

const config = {
  'page-1': page1,
  'page-2': page2,
  'page-3': page3,
  'page-3.1': page3_1,
  'page-4': page4,
  'page-5': page5,
  'page-5.1': page5_1,
  'page-5.2': page5_2,
  'page-5.3': page5_3,
  'page-6': page6,
  'page-7': page7,
  'page-7.1': page7_1,
  'page-7.1.2': page7_1_2,
  'page-7.2.2': page7_2_2,
  'page-7.2': page7_2,
  'page-8': page8,
  'page-8.1': page8_1,
  'page-9': page9,
  'page-10': page10,
  'page-11': page11,
  'page-12': page12,
  'page-13': page13,
  'page-14': page14,
  'page-15': page15
};

export default config;
